<div class="home">
  <div class="home__inner">
    <!-- Hero / Announcements carousel -->
    <section class="hero" *ngIf="announcementsLoading" aria-busy="true" aria-label="Chargement de la bannière">
      <div class="hero__card hero-skeleton">
        <div class="hero-skeleton__content">
          <span class="hero-skeleton__bar hero-skeleton__bar--kicker"></span>
          <span class="hero-skeleton__bar hero-skeleton__bar--title"></span>
          <span class="hero-skeleton__bar hero-skeleton__bar--title hero-skeleton__bar--short"></span>
          <span class="hero-skeleton__bar hero-skeleton__bar--subtitle"></span>
          <span class="hero-skeleton__bar hero-skeleton__bar--cta"></span>
        </div>
      </div>
    </section>

    <section class="hero" *ngIf="!announcementsLoading && announcements[activeAnnouncementIndex] as activeAnnouncement">
      <div class="hero__card" role="region" aria-roledescription="carousel" aria-label="Bannière promotionnelle">
        <div class="hero__media" aria-hidden="true">
          <img [src]="activeAnnouncement.imageUrl" [alt]="" />
        </div>

        <div class="hero__content hero__content--overlay" aria-live="polite" aria-atomic="true">
          <div class="hero__kicker">Saarvie Protection</div>
          <h1 class="hero__title">{{ activeAnnouncement.title }}</h1>
          <p class="hero__subtitle">{{ activeAnnouncement.subtitle }}</p>
          <a
            class="hero__cta"
            [routerLink]="activeAnnouncement.ctaRoute || '/accueil'"
            [fragment]="activeAnnouncement.ctaRoute === '/accueil' ? 'produits' : undefined">
            {{ activeAnnouncement.ctaLabel || 'NOS PRODUITS' }}
          </a>
        </div>

        <div class="hero__nav" *ngIf="announcements.length > 1">
          <button
            class="hero__arrow hero__arrow--prev"
            type="button"
            aria-label="Annonce précédente"
            (click)="prevAnnouncement()">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button
            class="hero__arrow hero__arrow--next"
            type="button"
            aria-label="Annonce suivante"
            (click)="nextAnnouncement()">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <div class="hero__dots" *ngIf="announcements.length > 1">
          <button
            *ngFor="let a of announcements; let i = index"
            class="hero__dot"
            [class.hero__dot--active]="i === activeAnnouncementIndex"
            [attr.aria-label]="'Annonce ' + (i + 1)"
            [attr.aria-current]="i === activeAnnouncementIndex ? 'true' : null"
            type="button"
            (click)="selectAnnouncement(i)">
          </button>
        </div>
      </div>
    </section>
  </div>

  <!-- Products -->
  <section class="section section--products" id="produits">
    <div class="home__inner">
      <div class="section__head">
        <span class="section__accent" aria-hidden="true"></span>
        <h2 class="section__title">Nos produits</h2>
        <p class="section__subtitle">
          Cliquez sur un produit pour afficher ses descriptions, packages et formules.
        </p>
      </div>

      <div
        class="product-grid"
        *ngIf="productsLoading"
        aria-busy="true"
        aria-label="Chargement des produits">
        <article class="product-card product-card--skeleton" *ngFor="let slot of productSkeletons">
          <div class="product-card__media product-skeleton__media"></div>
          <div class="product-card__body">
            <div class="product-card__meta">
              <span class="product-skeleton__bar product-skeleton__bar--meta"></span>
              <span class="product-skeleton__bar product-skeleton__bar--meta-short"></span>
            </div>
            <span class="product-skeleton__bar product-skeleton__bar--title"></span>
            <span class="product-skeleton__bar product-skeleton__bar--desc"></span>
            <span class="product-skeleton__bar product-skeleton__bar--desc product-skeleton__bar--desc-short"></span>
            <div class="product-card__specs">
              <span class="product-skeleton__bar product-skeleton__bar--spec"></span>
              <span class="product-skeleton__bar product-skeleton__bar--spec"></span>
              <span class="product-skeleton__bar product-skeleton__bar--spec"></span>
            </div>
            <div class="product-card__footer">
              <span class="product-skeleton__bar product-skeleton__bar--btn"></span>
              <span class="product-skeleton__bar product-skeleton__bar--btn"></span>
            </div>
          </div>
        </article>
      </div>

      <div class="products-state products-state--error" *ngIf="!productsLoading && productsError">
        <p>{{ productsError }}</p>
        <button type="button" class="products-retry" (click)="reloadProducts()">Réessayer</button>
      </div>

      <div class="products-state" *ngIf="!productsLoading && !productsError && products.length === 0">
        Aucun produit disponible pour le moment.
      </div>

      <div class="product-grid" *ngIf="!productsLoading && !productsError && products.length">
        <article class="product-card" *ngFor="let p of products; trackBy: trackByProductId">
          <a
            class="product-card__media-link"
            [routerLink]="['/produits', p.id]"
            [attr.aria-label]="'Voir les détails de ' + p.name">
            <div class="product-card__media">
              <img
                class="product-card__img"
                [src]="p.imageUrl"
                [alt]="p.name"
                loading="lazy"
                referrerpolicy="no-referrer"
                (error)="onProductImageError($event)" />
              <span class="product-card__badge" aria-hidden="true">
                <mat-icon>visibility</mat-icon>
                Aperçu
              </span>
            </div>
          </a>

          <div class="product-card__body">
            <a class="product-card__title-link" [routerLink]="['/produits', p.id]">
              <div class="product-card__meta">
                <span>{{ p.packagesCount }} package{{ p.packagesCount > 1 ? 's' : '' }} disponible{{ p.packagesCount > 1 ? 's' : '' }}</span>
                <span>{{ p.descriptionsCount }} desc.</span>
              </div>

              <div class="product-card__title">{{ p.name }}</div>
              <p class="product-card__desc">{{ p.description }}</p>
            </a>

            <div class="product-card__specs">
              <span><mat-icon>layers</mat-icon> {{ p.packagesCount }} packs</span>
              <span><mat-icon>list_alt</mat-icon> {{ p.descriptionsCount }} desc.</span>
              <span><mat-icon>rule</mat-icon> {{ p.nestedProductsCount }} formules</span>
            </div>

            <div class="product-card__footer">
              <a class="product-card__btn product-card__btn--secondary" [routerLink]="['/produits', p.id]">
                Voir détails
              </a>
              <a
                class="product-card__btn product-card__btn--subscribe"
                [routerLink]="['/souscription', p.id]">
                Souscription
              </a>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- Nos services — quick actions -->
  <section class="section section--services" id="services">
    <div class="home__inner">
      <div class="section__head section__head--accent">
        <div class="section__accent-bar"></div>
        <div>
          <h2 class="section__title section__title--dark">Nos services</h2>
          <p class="section__subtitle">Accédez rapidement à vos actions</p>
        </div>
      </div>

      <div class="action-grid">
        <a
          class="action-card"
          *ngFor="let action of quickActions; trackBy: trackByActionTitle"
          [routerLink]="action.route"
          [fragment]="action.fragment || undefined"
          [style.--accent]="action.color">
          <div class="action-card__icon" [style.background]="action.gradient">
            <mat-icon>{{ action.icon }}</mat-icon>
          </div>
          <div class="action-card__title">{{ action.title }}</div>
          <p class="action-card__desc">{{ action.description }}</p>
          <mat-icon class="action-card__arrow">arrow_forward</mat-icon>
        </a>
      </div>
    </div>
  </section>

  <!-- Agencies -->
  <section class="section section--agencies" id="agences">
    <div class="home__inner">
      <div class="section__head">
        <span class="section__accent" aria-hidden="true"></span>
        <h2 class="section__title">Nos agences</h2>
        <p class="section__subtitle">Retrouvez nos bureaux et leur localisation au Cameroun.</p>
      </div>

      <div class="products-state" *ngIf="agenciesLoading">
        Chargement des agences…
      </div>

      <div class="products-state products-state--error" *ngIf="!agenciesLoading && agenciesError">
        <p>{{ agenciesError }}</p>
        <button type="button" class="products-retry" (click)="reloadAgencies()">Réessayer</button>
      </div>

      <div class="products-state" *ngIf="!agenciesLoading && !agenciesError && agencies.length === 0">
        Aucune agence disponible pour le moment.
      </div>

      <div class="agency-grid" *ngIf="!agenciesLoading && !agenciesError && agencies.length">
        <article class="agency-card" *ngFor="let a of agencies; trackBy: trackByAgencyId">
          <div class="agency-card__accent" [style.background]="a.accentColor"></div>

          <div class="agency-card__body">
            <div class="agency-card__top">
              <h3 class="agency-card__name">{{ a.name }}</h3>
              <span
                class="agency-card__tag"
                [style.color]="a.accentColor"
                [style.background]="a.accentColor + '1a'">
                {{ a.tag }}
              </span>
            </div>

            <div class="agency-card__divider"></div>

            <div class="agency-card__row">
              <div class="agency-card__icon" [style.background]="a.accentColor">
                <mat-icon>place</mat-icon>
              </div>
              <div class="agency-card__text">
                <span class="agency-card__label">Adresse</span>
                <span class="agency-card__value">{{ a.address }}</span>
              </div>
            </div>
          </div>

          <div class="agency-card__footer">
            <a
              class="agency-card__map"
              [href]="a.mapUrl"
              target="_blank"
              rel="noopener noreferrer"
              [style.color]="a.accentColor">
              Voir sur la carte
              <mat-icon>open_in_new</mat-icon>
            </a>
          </div>
        </article>
      </div>
    </div>
  </section>
</div>
